import { render, staticRenderFns } from "./sms-edit.vue?vue&type=template&id=fa27b5a4&"
import script from "./sms-edit.vue?vue&type=script&lang=js&"
export * from "./sms-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa27b5a4')) {
      api.createRecord('fa27b5a4', component.options)
    } else {
      api.reload('fa27b5a4', component.options)
    }
    module.hot.accept("./sms-edit.vue?vue&type=template&id=fa27b5a4&", function () {
      api.rerender('fa27b5a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/sms-edit.vue"
export default component.exports